<template>
  <input
    :placeholder="placeholder"
    v-maskito="maskOptions"
    v-model="dateTime"
    inputmode="numeric"
    type="text"
    :disabled="disabled"
    :class="[v?.$error ?
               'border-red-200 text-red-500/90 focus:ring-red-500/90 focus:border-red-500/90' :
               'border-blue-200 focus:ring-blue-500/90 text-blue-500/90',
             'shadow-sm block font-semibold w-full text-sm focus:bg-whitesmoke-100  border-2 rounded-xl  tabular-nums tracking-wide',
             disabled ? 'opacity-50 cursor-not-allowed' : '']"
  >
</template>

<script setup>

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

import { defineProps, defineEmits, defineModel, ref, watch, computed, onMounted } from "vue";

import { maskito } from '@maskito/vue';
import { maskitoDateTimeOptionsGenerator, maskitoWithPlaceholder } from '@maskito/kit';


const placeholder = 'dd.mm.yyyy, --:--';

const model = defineModel();

const props = defineProps({
    v: Object,
    name: String,
    disabled: {
        type: Boolean,
        default: false
    },
});

const vMaskito = maskito;

const dateTime = ref();

const dateOptions = maskitoDateTimeOptionsGenerator({
    dateMode: 'dd/mm/yyyy',
    timeMode: 'HH:MM',
    dateSeparator: '.',
    min: new Date('1800-01-01'),
    max: new Date('2100-01-01'),
});


const {
    plugins,
    ...placeholderOptions
} = maskitoWithPlaceholder(placeholder, false);

const maskOptions = {
    ...dateOptions,
    plugins: plugins.concat(dateOptions.plugins || []),
    preprocessors: [
        ...placeholderOptions.preprocessors,
        ...dateOptions.preprocessors,
    ],
    postprocessors: [
        ...dateOptions.postprocessors,
        ...placeholderOptions.postprocessors,
    ],
}
if(model.value) {
    dateTime.value = dayjs(model.value).format("DD.MM.YYYY, HH:mm").toString()
}

watch(dateTime, (value) => {
    if (dayjs(value, "DD.MM.YYYY, HH:mm", true).isValid()) {
        props.v.$touch();
        model.value = dayjs(value, "DD.MM.YYYY, HH:mm", true).toDate();
    } else {
        model.value = null;
    }

});

</script>